module.exports = __webpack_public_path__ + "img/box3_img4.0c7ed961.png";